import React from 'react';

const VerifyCodeFormContext = React.createContext({
    inputLabel: undefined,
    inputRefs: undefined,
    onInputChange: undefined,
    onKeyDown: undefined,
    values: undefined,
    error: undefined,
    showResendClicked: undefined,
    codeSentLabel: undefined,
    onCodeResend: undefined,
    linkLabel: undefined,
    inputsDisabled: undefined,
    resendDisabled: undefined,
});

VerifyCodeFormContext.displayName = 'VerifyCodeFormContext';

export default VerifyCodeFormContext;
